<template>
  <div
    class="honorRoll"
    :style="{
      background: `linear-gradient(180deg, ${honorRollConfig.gradientBgTop}, ${honorRollConfig.gradientBgBottom})`,
    }"
  >
    <header>
      <header-banner :bannerUrl="honorRollConfig.leaderBoardTopBanner" />
    </header>
    <section>
      <div class="subjectList">
        <div
          v-for="(item, index) in subjectData"
          :key="index"
          @click="changeSubject(index)"
        >
          <subject-btn
            :honorRollConfig="honorRollConfig"
            :isActive="item.isActive"
            :text="item.name"
          />
        </div>
      </div>
      <div class="list" v-if="list.length > 0">
        <div class="item" v-for="(item, index) in list" :key="index">
          <honor-roll-module
            :numbers="index"
            :honorData="item"
            :honorRollConfig="honorRollConfig"
            :homeConfig="homeConfig"
            @shareClick="shareClick"
          />
        </div>
      </div>
      <div class="emptyData" v-else>
        <img :src="honorRollConfig.noRankDefaultImage" />
        <p>暂无段位提升</p>
      </div>
    </section>
    <van-popup style="width: 100%" v-model="isShowPopUpDialog" :lazy-render="false" :overlay="rankPoster.isShow" :close-on-click-overlay="rankPoster.isShow">
      <battalionPoster
        :isFixHeight="isFixHeight"
        :posterUrl="rankPoster.posterUrl"
        :isShow="rankPoster.isShow"
        :capturing="rankPoster.isCapturing"
        @OnCancelPoster="handleCancelRankPoster"
      >
        <!-- 生成海报的 -->
        <div id="rankPosterContainer">
          <rank
            :key="'rank-' + rankPosterKey"
            v-if="rankPoster.isPoster == 1"
            :teamInfo="teamInfo"
            :posterData="rankPosterData"
            :rankPosterConfig="rankPosterConfig"
            :seasonId="seasonId"
            @poster-ready="captureRankPoster"
            @poster-failed="handleRankPosterFailed"
          ></rank>
        </div>
      </battalionPoster>
    </van-popup>
  </div>
</template>

<script>
import arrow from "./components/arrow.vue";
import emptyData from "./components/emptyData.vue";
import slideDownSelect from "./components/slideDownSelect.vue";
import InputBox from "./components/inputBox.vue";
import SubjectBtn from "@views/WinterGame/components/subjectBtn.vue";
import HonorRollModule from "@views/WinterGame/components/honorRollModule.vue";
import {
  serviceCenterseGment,
  queryseasonpersonalhome,
  queryseasonpersonaleaderbroad,
  queryseasonconfigbyseasonid,
} from "../../api/winterGame";
import { Toast } from "vant";
import battalionPoster from "@components/SquirrelCupII/battalion-poster.vue";
import BattleReport from "@views/WinterGame/components/poster/battleReport.vue";
import Rank from "@views/WinterGame/components/poster/rank.vue";
import { beginPosterCapture } from "@/util/posterCapture";
import posterCaptureMixin from "@/views/WinterGame/mixins/posterCaptureMixin";
import HeaderBanner from "@views/WinterGame/components/headerBanner.vue";

export default {
  mixins: [posterCaptureMixin],
  components: {
    HeaderBanner,
    Rank,
    BattleReport,
    battalionPoster,
    HonorRollModule,
    SubjectBtn,
    InputBox,
    arrow,
    emptyData,
    slideDownSelect,
  },
  data() {
    return {
      isFixHeight: false, // 海报是否适配高度
      isShowPopUpDialog: false, // 是否显示弹出框
      list: [],
      honorRollData: null,
      currentIndex: 0,
      subjectData: [
        {
          id: 1,
          name: "数学",
          isActive: true,
        },
        {
          id: 2,
          name: "英语",
          isActive: false,
        },
        {
          id: 3,
          name: "语文",
          isActive: false,
        },
      ],
      currentCampusId: 88,
      currentUserId: 98,
      teamInfo: {
        cupYearSeason: "",
      },
      rankPoster: {
        isShow: false,
        isPoster: -1,
        posterUrl: "",
        isCapturing: false,
      },
      rankPosterKey: 0,
      rankPosterData: null,
      scheduleId: "",
      seasonId: "",
      currentSeason: null,
      currentAcountId: "",
      isHonorRoll: true,
      honorRollConfig: {
        gradientBgTop: "", // 背景色值 渐变上
        gradientBgBottom: "", // 背景色值 渐变下
        subjectBtnActive: "", // 学科按钮点击
        subjectBtnNormal: "", // 学科按钮非点击
        subjectTextActiveColor: "", // 学科文字点击色值
        subjectTextNormalColor: "", // 学科文字非点击色值
        badgeBgGradientTop: "", // 段位徽章背景色值 渐变上
        badgeBgGradientBottom: "", // 段位徽章背景色值 渐变下
        badgeStripeGradientTop: "", // 段位徽章背景条纹色 渐变上
        badgeStripeGradientBottom: "", // 段位徽章背景条纹色 渐变下
        leaderBoardTopBanner: "", // 升段光荣榜顶部图
        noRankDefaultImage: "", // 无段位提升缺省图
      },
      homeConfig: {},
      rankPosterConfig: {
        rankNormal: "", // 段位（普通）
        rankKing: "", // 段位（王者）
      },
    };
  },
  created() {
    document.title = this.$route.meta.title || "松鼠杯";
  },
  mounted() {
    this.currentSeason = this.$route.params.currentSeason;
    this.scheduleId = this.$route.params.scheduleId;
    this.seasonId = this.$route.params.seasonId;
    console.log("seasonId", this.seasonId);
    this.currentAcountId = this.$route.params.currentAcountId;
    this.initTeamInfo();
    this.setUserInfo();

    if (this.currentUserId) {
      this.serviceCenterseGment();
    }
    this.querySeasonPersonalHome();
    this.querySeasonPersonaLeaderBroad();
    this.querySeasonConfigBySeasonId();
  },
  methods: {
    querySeasonPersonalHome() {
      let pkParams = JSON.parse(localStorage.getItem("pkParams"));
      let seasonTagId = this.seasonId ? this.seasonId : pkParams.seasonId;
      queryseasonpersonalhome({
        param: {
          seasonTagId: seasonTagId,
        }
      }).then(res => {
        if (res.code == 0) {
          this.homeConfig = res.data;
        } else {
          Toast(res.message);
        }
      });
    },
    querySeasonPersonaLeaderBroad() {
      let pkParams = JSON.parse(localStorage.getItem("pkParams"));
      let seasonTagId = this.seasonId ? this.seasonId : pkParams.seasonId;
      console.log("seasonTagId", seasonTagId);
      queryseasonpersonaleaderbroad({
        param: {
          seasonTagId: seasonTagId,
        },
      }).then((res) => {
        if (res.code == 0) {
          this.honorRollConfig = res.data;
        } else {
          Toast(res.message);
        }
      });
    },
    // 查询海报相关信息
    querySeasonConfigBySeasonId() {
      let pkParams = JSON.parse(localStorage.getItem("pkParams"));
      let seasonTagId = this.seasonId ? this.seasonId : pkParams.seasonId;
      console.log("seasonTagId", seasonTagId);
      queryseasonconfigbyseasonid({
        param: {
          seasonTagId: seasonTagId,
        },
      }).then((res) => {
        if (res.code == 0) {
          this.rankPosterConfig = res.data;
        } else {
          Toast(res.message);
        }
      });
    },
    setUserInfo() {
      const userInfoId = JSON.parse(localStorage.getItem("userInfoId"));
      if (userInfoId) {
        this.currentCampusId = userInfoId.campusId;
        this.currentUserId = userInfoId.agentUserId;
      } else {
        Toast("找不到参赛信息");
      }
    },
    async serviceCenterseGment() {
      let params = {
        param: {
          currentCampusId: this.currentCampusId,
          currentUserId: this.currentUserId,
          scheduleId: this.scheduleId,
          seasonId: this.seasonId,
          accountId: this.currentAcountId,
        },
      };
      let res = await serviceCenterseGment(params);
      if (res.code == 0) {
        if (res.data.english) {
          res.data.english.forEach((item) => {
            item.created_at = item.created_at.substring(0, 10);
          });
        }
        if (res.data.chinese) {
          res.data.chinese.forEach((item) => {
            item.created_at = item.created_at.substring(0, 10);
          });
        }
        if (res.data.math) {
          res.data.math.forEach((item) => {
            item.created_at = item.created_at.substring(0, 10);
          });
        }
        this.honorRollData = res.data;
        this.setListData(0);
      } else {
        Toast(res.message);
      }
    },
    changeSubject(index) {
      this.currentIndex = index;
      let subjectData = this.subjectData.map((item, i) => {
        if (i == index) {
          item.isActive = true;
        } else {
          item.isActive = false;
        }
        return item;
      });
      this.subjectData = subjectData;
      this.setListData(index);
    },
    setListData(index) {
      if (index == 1) {
        this.list = this.honorRollData.english || [];
      } else if (index == 0) {
        this.list = this.honorRollData.math || [];
      } else {
        this.list = this.honorRollData.chinese || [];
      }
    },
    shareClick(data) {
      this.rankPosterData = {
        realName: data.real_name,
        subjectName: this.subjectData[this.currentIndex].name,
        date: data.created_at,
        serviceName: data.service_name,
        segmentName: data.segment_name,
        segmentLevel: data.segment_level,
        segmentId: data.segment_id,
        segmentIcon: data.segment_icon,
      };

      this.lookRankPoster();
    },
    lookRankPoster() {
      beginPosterCapture(this.rankPoster);
      this.rankPosterKey += 1;
      this.rankPoster.isPoster = 1;
      this.isShowPopUpDialog = true;
    },
    handleCancelRankPoster(type) {
      this.rankPoster.isShow = false;
      this.cancelPosterCaptureState(this.rankPoster);
      this.isShowPopUpDialog = false;
    },
    handleRankPosterFailed() {
      this.cancelPosterCaptureState(this.rankPoster);
      this.isShowPopUpDialog = false;
      this.rankPoster.isPoster = -1;
      Toast('海报背景加载失败，请重试');
    },
    initTeamInfo() {
      let teamInfo = localStorage.getItem("teamInfo");
      this.teamInfo = JSON.parse(teamInfo);
    },
  },
};
</script>

<style lang="less" scoped>
.honorRoll {
  min-height: 100vh;
  overflow: hidden;
  &.spring_2023 {
    background: linear-gradient(180deg, #001f6d 0%, #081f65 100%);
  }
  &.summer_2023 {
    //background: linear-gradient(180deg, #0059c7 0%, #0098ff 100%);
    background: linear-gradient(180deg, #0250b0 0%, #0098ff 100%);
  }
  &.autumn_2023 {
    background: linear-gradient(180deg, #6b3510 0%, #865d30 100%);
  }
  &.winter_2024 {
    background: linear-gradient(180deg, #2ba8f6 0%, #3f85ef 100%);
  }
  &.spring_2024 {
    background: linear-gradient(180deg, #3a8667 0%, #3f9385 100%);
  }
  &.summer_2024 {
    background: linear-gradient(181deg, #098cce 0%, #4fbad7 100%);
  }
  &.autumn_2024 {
    background: linear-gradient(180deg, #9d5618 0%, #bc7131 100%);
  }
  &.winter_2025 {
    background: linear-gradient(180deg, #7a9af5 0%, #7aa4ec 100%);
  }
  &.spring_2025 {
    background: linear-gradient(180deg, #58a96e 0%, #7eb656 100%);
  }
  &.summer_2025 {
    background: linear-gradient(180deg, #0289cb 0%, #11a3c2 100%);
  }
  header {
    height: 334px;
    position: relative;
    img {
      width: 100%;
    }
    .honorText {
      position: absolute;
      bottom: 30px;
      left: calc(50% - 160px);
      width: 320px;
    }
  }
  .subjectList {
    display: flex;
    justify-content: center;
    align-items: center;
    div {
      // margin-right: 16px;
      margin: 0 8px;
    }
  }

  .list {
    margin-top: 24px;
    .item {
      // width: 90%;
      margin: auto;
      padding: 0 48px;
      margin-bottom: 32px;
    }
  }
  .emptyData {
    text-align: center;
    margin-top: 86px;
    img {
      width: 386px;
    }
    p {
      margin-top: 48px;
      height: 40px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 40px;
    }
  }
}
</style>
